import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import React from "react";
import { useTranslation } from "react-i18next";
import { SortDirection } from "../../generate";
import Select from "../Inputs/Select";
import { Column, Sort } from "./types";

interface Props {
  columns: Column[];
  sort: Sort;
  handleSort: (value: Sort) => void;
}

interface DirectionButtonProps {
  onClick: () => void;
  direction: SortDirection;
}

const DirectionButton: React.FC<DirectionButtonProps> = ({ onClick, direction }) => {
  const [t] = useTranslation();
  return (
    <button className="btn btn-primary w-12" onClick={onClick} aria-label={t("common.toggleSort")}>
      {direction === SortDirection.Ascending && <ArrowDownwardIcon />}
      {direction === SortDirection.Descending && <ArrowUpwardIcon />}
    </button>
  );
};

const MobileSorter: React.FC<Props> = ({ columns, sort, handleSort }) => {
  const [t] = useTranslation();
  const sortOptions = columns.map((column) => ({ value: column.dataKey, label: column.label }));

  const changeSortField = (value: string) => {
    const newSort = {
      ...sort,
      field: value,
      direction: SortDirection.Ascending,
    };
    handleSort(newSort);
  };

  const toggleSortDirection = () => {
    const direction = sort.direction === SortDirection.Ascending ? SortDirection.Descending : SortDirection.Ascending;
    const newSort = {
      ...sort,
      direction,
    };
    handleSort(newSort);
  };

  return (
    <div className="pb-4 flex sm:mt-4">
      <Select
        containerClasses="border"
        label={t("common.sortBy")}
        value={sort.field}
        options={sortOptions}
        handleChange={changeSortField}
        endAdornment={<DirectionButton onClick={toggleSortDirection} direction={sort.direction} />}
      />
    </div>
  );
};

export default MobileSorter;
